/**
 * Short, stable, filesystem-safe hashes.
 *
 * Used wherever the output tree needs a deterministic filename derived from
 * content or a URL rather than from user-controlled text — chat-folder
 * disambiguation here, and per §7/§8 the same pattern names mail files
 * (`<hash>.eml`) and Teams inline-image assets, so resume can tell what is
 * already on disk without re-fetching it first.
 */

/** Hex-encoded SHA-256 of `input`, truncated to `length` characters. */
export async function shortHash(input: string, length = 10): Promise<string> {
    const bytes = new TextEncoder().encode(input);
    const digest = await crypto.subtle.digest("SHA-256", bytes);
    const hex = Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, "0")).join(
        ""
    );
    return hex.slice(0, length);
}
